// React libraries
import React from 'react';

// Material UI components
import MUITooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

// Local imports
import { useStyles } from './TooltipStyles';
import { FONT_FAMILY } from '../../constants';

// Rest operator helper function
const __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

export const Tooltip = (props) => {
    const { enterNextDelay, leaveDelay } = props;
    const classes = __rest(useStyles(props), []);

    return (
        <MUITooltip
            classes={classes}
            arrow={true}
            {...props}
            title={
                <>
                    <Typography 
                        style={{ 
                            fontFamily: FONT_FAMILY.ROBOTO_REGULAR, 
                            fontSize: 12, 
                            letterSpacing: 0.17 
                        }}
                    >
                        {props.title}
                    </Typography>
                    {props?.subTitle}
                </>
            }
            enterNextDelay={enterNextDelay}
            leaveDelay={leaveDelay}
        />
    );
};

export default Tooltip;